import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const LazyIframe = lazy(async () => await import('./iframe'));

export const IframeRouters: RouteObject[] = [
  {
    path: 'training/*',
    element: (<LazyIframe />)
  },
  {
    path: 'shoteyes/*',
    element: (<LazyIframe />)
  }
];
